export type ShareErrorType = {
  type: string;
  message: string;
  showBanner?: boolean;
};

export interface AppointmentProposalShareState {
  isLoading: boolean;
  errors: ShareErrorType[];
}

export const initState: AppointmentProposalShareState = {
  isLoading: false,
  errors: [],
};

type ErrorPayload = Omit<ShareErrorType, 'type'>;

type Action =
  | { type: 'SHARE_CUSTOMER_SURVEY' }
  | { type: 'SHARE_CUSTOMER_SURVEY_SUCCESS' }
  | {
      type: 'SHARE_CUSTOMER_SURVEY_FAILURE';
      payload: { error: ErrorPayload };
    }
  | { type: 'CLEAR_ALL_ERRORS' };

export const appointmentProposalShareReducer = (
  state: AppointmentProposalShareState,
  action: Action
): AppointmentProposalShareState => {
  switch (action.type) {
    case 'SHARE_CUSTOMER_SURVEY':
      return {
        ...state,
        isLoading: true,
        errors: state.errors.filter(
          (e) => e.type !== 'SHARE_CUSTOMER_SURVEY_FAILURE'
        ),
      };

    case 'SHARE_CUSTOMER_SURVEY_SUCCESS':
      return {
        ...state,
        isLoading: false,
      };

    case 'SHARE_CUSTOMER_SURVEY_FAILURE':
      return {
        ...state,
        isLoading: false,
        errors: [
          ...state.errors.filter(
            (e) => e.type !== 'SHARE_CUSTOMER_SURVEY_FAILURE'
          ),
          { type: action.type, ...action.payload.error },
        ],
      };

    case 'CLEAR_ALL_ERRORS':
      return {
        ...state,
        errors: [],
      };

    default:
      return state;
  }
};
